document.addEventListener("click", function (e) {
  const wistiaBtn = e.target.closest("#see-it-video-wistia");
  const iframeBtn = e.target.closest("#see-it-video");
  const mp4Btn = e.target.closest("#see-it-video-mp4");
  const videodiv = document.querySelector(".product__main-video");

  if (!videodiv) return;

  // Wistia Video Toggle
  if (wistiaBtn) {
    const pauseBtn = videodiv.querySelector('.w-css-reset[aria-label="Pause"]');
    const playBtn = videodiv.querySelector('.w-css-reset[aria-label="Play Video"]');

    if (wistiaBtn.classList.contains("active")) {
      if (pauseBtn) pauseBtn.click();
    } else {
      if (playBtn) playBtn.click();
    }

    wistiaBtn.classList.toggle("active");
    videodiv.classList.toggle("show");
    return;
  }

  // iframe-based Video Toggle
  if (iframeBtn) {
    const videomaindiv = document.querySelector(".video_player_main");
    if (!videomaindiv) return;

    const imgSrc = videodiv.getAttribute("data-src");
    let newSrc = imgSrc;

    if (iframeBtn.classList.contains("active")) {
      newSrc = imgSrc.replace("autoplay=1", "autoplay=0");
    } else {
      if (imgSrc.includes("autoplay")) {
        newSrc = imgSrc.replace("autoplay=0", "autoplay=1&controls=0");
      } else {
        newSrc = imgSrc + "?autoplay=1&controls=0";
      }
    }

    videomaindiv.src = newSrc;
    iframeBtn.classList.toggle("active");
    videodiv.classList.toggle("show");
    return;
  }

  // MP4 Video Toggle
  if (mp4Btn) {
    const videomaindiv = document.querySelector(".video_player_main");
    if (!videomaindiv || typeof videomaindiv.play !== "function") return;

    if (mp4Btn.classList.contains("active")) {
      videomaindiv.pause();
      videomaindiv.currentTime = 0;
    } else {
      videomaindiv.play();
    }

    mp4Btn.classList.toggle("active");
    videodiv.classList.toggle("show");
    return;
  }
});
